import wAxios from '@/plugins/w/axios/models/axios'
import { defineStore } from 'pinia'

interface State {
	unreadNotifications: Array<Object> | null,
	// notificationsHistory: Array<Object> | null
}

export const useNotificationsStore = defineStore('notifications', {
	state: (): State => ({
		unreadNotifications: localStorage.getItem('mdx_kz_unread_notifications') ? JSON.parse(localStorage.getItem('mdx_kz_unread_notifications') || '[]') : null,
		// notificationsHistory: localStorage.getItem('mdx_kz_notifications_history') ? JSON.parse(localStorage.getItem('mdx_kz_notifications_history') || '[]') : null
	}),

	actions: {
		async loadUnreadNotifications() {
			return new Promise((resolve, reject) => {
				wAxios.get_auth_data('v1/notifications')
					.then((unreadNotifications: Array<Object>) => {

						this.unreadNotifications = unreadNotifications
						localStorage.setItem('mdx_kz_unread_notifications', JSON.stringify(unreadNotifications))

						resolve(unreadNotifications)
					}).catch(error => {
						reject(error)
					})
			})
		},

		// async loadNotificationsHistory() {
		// 	return new Promise((resolve, reject) => {
		// 		wAxios.get_auth_data('v1/notifications/read')
		// 			.then((notificationsHistory: Array<Object>) => {

		// 				this.notificationsHistory = notificationsHistory
		// 				localStorage.setItem('mdx_kz_notifications_history', JSON.stringify(notificationsHistory))

		// 				resolve(notificationsHistory)
		// 			}).catch(error => {
		// 				reject(error)
		// 			})
		// 	})
		// },

		setNotificationAsRead(notification) {
			return new Promise((resolve, reject) => {
				this.unreadNotifications = this.unreadNotifications.filter(n => n.id !== notification.id)

				wAxios.post_auth_data('v1/notifications/read', { notification_id: notification.id })
					.then(() => {
						localStorage.setItem('mdx_kz_unread_notifications', JSON.stringify(this.unreadNotifications))

						// this.loadNotificationsHistory()

						resolve(true)
					})
					.catch(error => {
						this.unreadNotifications.unshift(notification)
						reject(error)
					})
			})
		}
	},

	getters: {
		latestUnreadNotification() {
			if (!this.unreadNotifications?.length)
				return null

			return this.unreadNotifications[0]
		},

		latestReadedNotifications() {
			if (!this.notificationsHistory?.length)
				return []

			return this.notificationsHistory
		}
	}
})